require(["71/registration/MicrositeRegistration.app"], function(regApp) {
	function init() {
		var app = new regApp.MicrositeRegistrationApp();
		app.init();
	}

	if (document.readyState !== 'loading') {
		setTimeout(init, 1);
	}
	else {
		document.addEventListener("DOMContentLoaded", init);
	}
})